const type = 'SET_DISPUTE_TREE_DISAGREEMENT';

const setDisputeTreeDisagreement = (data = []) => ({
  data,
  type,
});

export { type };
export default setDisputeTreeDisagreement;
